export default __webpack_public_path__ + "static/media/pressure-cleaning.a3a53d83.jpg";